import { render, staticRenderFns } from "./DashboardBottomNavBar.vue?vue&type=template&id=0ec98598&"
import script from "./DashboardBottomNavBar.vue?vue&type=script&lang=ts&"
export * from "./DashboardBottomNavBar.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardBottomNavBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports